import {
  searchDiscountApplyDetailById,
  doApproveDiscountApplyDetail
} from '@/api/sys/discount'
export default {
  namespaced: true,
  actions: {

    searchDiscountApplyDetailById({
      dispatch
    }, {
      vm,
      discountApplyDetailId
    }) {

      searchDiscountApplyDetailById(discountApplyDetailId)
        .then(res => {
          if (res.data.result == "1") {
            vm.activities = []
            vm.discountApplyDetail = res.data.discountApplyDetail
            vm.discountApply = res.data.discountApply
            vm.discountApplyDetailList = res.data.discountApplyDetailList

            let oneObj = new Object();
            oneObj.content = "发出申请"
            oneObj.timestamp = vm.fmtDate(vm.discountApply.applyDate)
            vm.activities.push(oneObj)
            for (var item in vm.discountApplyDetailList) {
              let obj = new Object();
              if (vm.discountApplyDetailList[item].approveState == "1") {
                if (vm.discountApplyDetailList[item].isExemptReview) {
                  obj.content = "免审批已通过"
                } else if (vm.discountApplyDetailList[item].sRole) {
                  obj.content = vm.discountApplyDetailList[item].sRole.roleName + " - 已通过"
                } else {
                  obj.content = "优惠审批人 - 已通过"
                }
                obj.timestamp = vm.fmtDate(vm.discountApplyDetailList[item].approveDate)
              } else if (vm.discountApplyDetailList[item].approveState == "2") {
                if (vm.discountApplyDetailList[item].isExemptReview) {
                  obj.content = "免审批未通过"
                } else if (vm.discountApplyDetailList[item].sRole) {
                  obj.content = vm.discountApplyDetailList[item].sRole.roleName + " - 未通过"
                } else {
                  obj.content = "优惠审批人 - 未通过"
                }
                obj.timestamp = vm.fmtDate(vm.discountApplyDetailList[item].approveDate)
              } else {
                if (vm.discountApplyDetailList[item].isExemptReview) {
                  obj.content = "免审批待审批"
                } else if (vm.discountApplyDetailList[item].sRole) {
                  obj.content = vm.discountApplyDetailList[item].sRole.roleName + " - 待审批"
                } else {
                  obj.content = "优惠审批人 - 待审批"
                }
              }
              vm.activities.push(obj)
            }

          } else {
            vm.$alert(res.data.message, '操作提示', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    doApproveDiscountApplyDetail({
      dispatch
    }, {
      vm,
      openId,
      applyDetailId,
      isAgree,
      remark
    }) {
      var data = new Object()
      data.openId = openId
      data.applyDetailId = applyDetailId
      data.isAgree = isAgree
      data.replyInfo = remark
      doApproveDiscountApplyDetail(data)
        .then(res => {
          if (res.data.result == 1) {
            vm.loading.close()
            vm.$alert('处理成功', '操作提示', {
              confirmButtonText: '确定'
            })
            vm.reresh()
          } else {
            vm.$alert(res.data.message, '操作提示', {
              confirmButtonText: '确定'
            })
            vm.loading.close()
            vm.reresh()
          }
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

  }
}